import { Box, Typography } from "@mui/material";
import { ACCENTS, COLORS, SHADOW } from "./emsTheme";

// EMS V2 shared card/button styles. All EMS V2 pages use the Prozo purple from emsTheme, so
// Tickets, Categories, settings and Analytics read as one product.
export const NAVY = COLORS.ink;
export const MUTED = COLORS.ink3;
export const BRAND_GRAD = ACCENTS.purple.grad;
export const cardSx = { border: `1px solid ${COLORS.grid}`, borderRadius: "12px", bgcolor: "#fff", boxShadow: SHADOW, overflow: "hidden" };
export const cardHeadSx = { display: "flex", alignItems: "center", gap: 1.25, px: 2, py: 1.5, borderBottom: `1px solid ${COLORS.grid}`, bgcolor: "#FBFAFD" };
export const cardIcSx = { width: 30, height: 30, borderRadius: "9px", display: "grid", placeItems: "center", background: ACCENTS.purple.grad, color: "#fff", flex: "0 0 auto",
    boxShadow: "0 4px 10px rgba(102,63,149,.25)", "& svg": { fontSize: 17 } };
export const gradientBtnSx = {
    textTransform: "none", fontWeight: 700, borderRadius: "10px", px: 2.75,
    backgroundImage: BRAND_GRAD, boxShadow: "0 6px 16px rgba(102,63,149,.28)",
    "&:hover": { backgroundImage: "linear-gradient(135deg, #7C52B0 0%, #4B2E70 100%)", boxShadow: "0 8px 20px rgba(102,63,149,.36)" },
    "&.Mui-disabled": { backgroundImage: "none", bgcolor: "#E9E5EF", color: "#9C94A8", boxShadow: "none" },
};
export const resetBtnSx = { textTransform: "none", fontWeight: 600, borderRadius: "10px", color: MUTED, borderColor: "#D6D0DF", "&:hover": { borderColor: COLORS.purple, color: COLORS.purple, bgcolor: COLORS.purpleSoft } };

const SectionCard = ({ icon, title, sub, children, headerExtra }) => (
    <Box sx={cardSx}>
        <Box sx={cardHeadSx}>
            <Box sx={cardIcSx}>{icon}</Box>
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 800, color: NAVY }}>{title}</Typography>
                {sub && <Typography sx={{ fontSize: 12, color: MUTED }}>{sub}</Typography>}
            </Box>
            {headerExtra}
        </Box>
        <Box sx={{ p: 2 }}>{children}</Box>
    </Box>
);

export default SectionCard;
